(function() {

    'use strict';

    angular.module('eclipseApp.myAccount').controller('paymentMethodCtrl', ['$scope', '$rootScope', 'uteEndpoint', '$http', '$state', '$modal', '$stateParams', 'commonService', 'uteModal', 'uteLocale', 'dtmService', 'dtmServiceConstants', function($scope, $rootScope, uteEndpoint, $http, $state, $modal, $stateParams, commonService, uteModal, uteLocale, dtmService, dtmServiceConstants) {

        $scope.paymentMethodSection = true ;
        $scope.isSubscriber=false;
        $scope.dtmRuleName = dtmServiceConstants.dtmRules.updateMOP.name;
        if ($rootScope.userInfo.profileType.subscriber !=null && $rootScope.userInfo.profileType.subscriber !=''){
          $scope.isSubscriber=$rootScope.userInfo.profileType.subscriber;
        }
        if ($stateParams.accountNumber) {
            $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
            $rootScope.userInfo.selectedSubscriberNo = '';
        } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber)) {
            $state.go('myAccount.overview');
        } else {
            if (!$stateParams.accountNumber) {
                $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
            }
        }

        var self = {};
        $scope.accountNumber = $stateParams.accountNumber;
        $scope.selectedAccountNumber = $stateParams.accountNumber;
        $scope.language = uteLocale.language;

        $scope.payment = {};

        $scope.config = {
            forFlow: 'my-account'
        };

        var scopeListener =  $rootScope.$on('initPaymentDetailsModal', function (event) {
          $scope.formData.selectedPaymentOption = '';
        });

        $scope.$on('$destroy', scopeListener);

        $scope.filterWirelessCFA = function (account){
          return ($rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless');
        };

        $scope.filterFraud = function (account){
          var selectedAccountDetail = _.find(commonService.accountDetails, function (accountDetail) {
            return accountDetail.accountNumber === account.accountNumber;
          });

          return (selectedAccountDetail.fraud !== true);
        };

        //Data to be passed to payment options directive
        $scope.paymentOptionsData = {
            loadInvoiceMOP: false
        };

        $scope.formData = {
            pac: {},
            pacc: {},
            invoice: {}
        };

        /*$scope.accountSelected = function(accountNumber) {
             console.log('inside $scope.accountSelected');
             $scope.selectedAccountNumber = accountNumber;
             self.loadPaymentDetail();
          };*/

        $scope.accountSelected = function(acc) {
            $state.go('myAccount.paymentMethod', {
                'accountNumber': acc
            });

        };
        var accountNumber = $scope.selectedAccountNumber;
        self.loadPaymentDetail = function() {
            var selectedAccountDetail;

            console.log('$scope.selectedAccountNumber', $scope.selectedAccountNumber);

            if ($scope.selectedAccountNumber) {
                selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
                    return accountDetail.accountNumber === $scope.selectedAccountNumber
                });
                console.log('selectedAccountDetail', selectedAccountDetail);
            }
            $scope.payment = {};

            if (selectedAccountDetail) {

                $scope.payment = {
                    accountBalance: selectedAccountDetail.balance,
                    date: selectedAccountDetail.paymentDueDate,
                    hasWireless: selectedAccountDetail.hasWireless,
                    MOPType: selectedAccountDetail.MOPType,
                    contactEmail: selectedAccountDetail.contactEmail
                };
                if (!$scope.payment.hasWireless && _.isEmpty($scope.payment.MOPType)) {
                    //alert("not wireless");
                    $http({
                        method: 'POST',
                        url: uteEndpoint('v1/billingArrangementData'),
                        data: {
                            billingArrangementId: $scope.selectedAccountNumber
                        }
                    }).success(function(data) {
                        $scope.payment.MOPType = data.methodOfPayment;
                        if ($scope.payment.MOPType === 'invoice') {
                            $scope.paymentOptionsData.loadInvoiceMOP = false;
                        } else {
                            $scope.paymentOptionsData.loadInvoiceMOP = true;
                        }
                    })
                }
                else{
                     if (selectedAccountDetail.MOPType === 'invoice') {
                         $scope.paymentOptionsData.loadInvoiceMOP = false;
                     } else {
                        $scope.paymentOptionsData.loadInvoiceMOP = true;
                     }
                }

            }

            console.log('$scope.payment', $scope.payment);
            console.log('$scope.paymentOptionsData.loadInvoiceMOP', $scope.paymentOptionsData.loadInvoiceMOP);

        };

        self.loadPaymentDetail();




        $scope.updatePaymentMethod = function() {
            console.log('updatePaymentMethod');
            $scope.$broadcast('validateMethod', []);
        };

        $scope.$on('methodValidated', function($event, methodInfo) {
            console.log("@paymentMethodCtrl(@methodInfo) ", methodInfo);

            uteModal.open({
                controller: 'updatePaymentModalCtrl',
                templateUrl: 'modules/my-account/payment-method/update-payment-method-modal.html',
                resolve: {
                    state: 'initial',
                    data: {
                        paymentType: methodInfo.type,
                        ccType: methodInfo.data.ccType,
                        ccNumber: methodInfo.data.ccNumber,
                        cvv: methodInfo.data.cvv,
                        ccExpiryMonth: methodInfo.data.ccExpiryMonth,
                        ccExpiryYear: methodInfo.data.ccExpiryYear,
                        ccName: methodInfo.data.ccName,
                        transitCode: methodInfo.data.transitCode,
                        bankCode: methodInfo.data.bankCode,
                        bankAccountNumber: methodInfo.data.accountNumber,
                        accountNumber: accountNumber,
                        uuid: $rootScope.userInfo.uuid,
                        contactEmail: $scope.payment.contactEmail
                    }
                },
                ok: function() {
                    console.log('PAY OK');
                    //self.loadPaymentDetails();
                },
                cancel: function() {
                    console.log('PAY CANCEL');
                   // self.loadPaymentDetails();
                }
            });
        });

        $scope.$on('methodValidatedError', function($event, data) {
            //alert(data.msg);
        });

        // TODO: Modularize
        self.init = function () {
          if ($rootScope.userInfo && ($rootScope.userInfo.accounts || []).length>0){
            if ($stateParams.accountNumber){
              $scope.selectedAccountNumber = $stateParams.accountNumber;
            }else{
              $scope.selectedAccountNumber = $rootScope.userInfo.accounts[0].accountNumber;
            }

           // self.loadPaymentDetails();
          }

        };

        /*self.loadPaymentDetails = function(){
          commonService.loadPaymentDetails($rootScope.userInfo.accounts).then(function(){
            $scope.accountSelected($scope.selectedAccountNumber);
          }, function(){
            $scope.accountSelected($scope.selectedAccountNumber);
          });
        };*/
        $scope.payNow = function() {
          $scope.formData.selectedPaymentOption = '';
          $state.go('myAccount.payNow', {
             'accountNumber': $stateParams.accountNumber
          });
        };

        $scope.viewBill = function() {
          $state.go('myAccount.viewInvoice', {
             'accountNumber': $stateParams.accountNumber
          });
        };

        self.init();

    }]);

})();
